// Geometri penempatan bangunan di editor: ukuran efektif (rotasi), tabrakan tapak, pencarian bangunan di petak.

// Ukuran efektif penempatan — rotasi ganjil (90°/270°) menukar w×h
export function dimsOf(defs, b) {
  const def = defs.find(d => d.bid === b.bid);
  let w = def?.w || 1, h = def?.h || 1;
  if ((b.rot || 0) % 2 === 1) [w, h] = [h, w];
  return [w, h];
}

// bid (opsional) = aset yang sedang ditaruh: billboard atap (def.atap) hanya bertabrakan dengan sesama aset atap
// dan boleh menumpang di petak gedung; sebaliknya gedung biasa mengabaikan aset atap.
export function occupied(defs, list, gx, gy, w, h, excludeIdx = -1, bid = null) {
  const atapDiri = !!defs.find(d => d.bid === bid)?.atap;
  return (list || []).some((b, i) => {
    if (i === excludeIdx) return false;
    const atapLain = !!defs.find(d => d.bid === b.bid)?.atap;
    if (atapDiri !== atapLain) return false;
    const [bw, bh] = dimsOf(defs, b);
    return gx < b.x + bw && gx + w > b.x && gy < b.y + bh && gy + h > b.y;
  });
}

export function buildingIndexAt(defs, buildings, gx, gy) {
  const di = b => { const [bw, bh] = dimsOf(defs, b); return gx >= b.x && gy >= b.y && gx < b.x + bw && gy < b.y + bh; };
  // aset atap (billboard di atas gedung) diutamakan agar tetap bisa dipilih/diketuk
  const atap = (buildings || []).findIndex(b => di(b) && defs.find(d => d.bid === b.bid)?.atap);
  return atap >= 0 ? atap : (buildings || []).findIndex(di);
}
